module.exports = __webpack_public_path__ + "d696b61555cf15a565413e52d4349373.pdf";